import { render, staticRenderFns } from "./label-value.vue?vue&type=template&id=7b118193&scoped=true&"
var script = {}
import style0 from "./label-value.vue?vue&type=style&index=0&id=7b118193&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b118193",
  null
  
)

export default component.exports